export default __webpack_public_path__ + "static/media/storage-service.2429341f.png";